<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>选配列表</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleAddNew">新增</el-button>
                </el-col>
            </el-row>
        </div>

        <el-table :data="fetchList">
            <el-table-column prop="productDetailId" label="ID">
            </el-table-column>
            <el-table-column prop="name" label="选配名称">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="结算方式">
                <div>
                    <span v-if="row.accessoryType == 1">按次</span>
                    <span v-if="row.accessoryType == 2">按天</span>
                </div>
            </el-table-column>
            <el-table-column prop="rental" label="价格">
            </el-table-column>
            <el-table-column prop="deposit" label="押金">
            </el-table-column>
            <el-table-column prop="productCount" label="设备数量" sortable>
            </el-table-column>
            <!-- <el-table-column prop="description" label="备注">
                </el-table-column> -->
            <el-table-column inline-template :context="_self" label="状态">
                <div>
                    <span v-if="row.isOnline">上架</span>
                    <span v-else>下架</span>
                </div>

            </el-table-column>
            <el-table-column inline-template :context="_self" prop="created" label="创建时间">
                <span>{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>

            <el-table-column inline-template :context="_self" width="200" label="操作">
                <span>
                                                        <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
                                                        <el-button @click="handleOnline($index, row)" v-if="!row.isOnline" type="text" size="small">上架</el-button>
                                                        <el-button @click="handleOff($index, row)" v-if="Role === '1' && row.isOnline" type="text" size="small">下架</el-button>
                                                        <el-button @click="handleAdd($index, row)" type="text" size="small">添加</el-button>
                                                    </span>
            </el-table-column>
            <el-table-column type="expand">
                <template slot-scope="props">
                                                <el-table :data="props.row.deviceArr" inline class="demo-table-expand">
                                                    <el-table-column prop="productIdentity" label="选配编码">
                                                    </el-table-column>
                                                    <el-table-column prop="storageArr.storageName" label="所在仓库">
                                                    </el-table-column>
                                                    <el-table-column inline-template :context="_self" label="状态">
                                                        <div>
                                                            <span v-if="row.isOnline">上架</span>
                                                            <span v-else>下架</span>
                                                        </div>

                                                    </el-table-column>
                                                    <el-table-column inline-template :context="_self" width="200" label="操作">
                                                        <span>
                                                            <el-button @click="handleView($index, row.rentHistory)" type="text" size="small">查看租赁历史</el-button>
                                                            <el-button @click="editDevice($index, props.row.deviceArr)" type="text" size="small">编辑</el-button>
                                                            <el-button @click="handleOnlined($index, props.row.deviceArr, props.row)" v-if="!row.isOnline" type="text" size="small">上架</el-button>
                                                            <el-button @click="handleOffd($index, props.row.deviceArr, props.row)" v-if="Role === '1' && row.isOnline" type="text" size="small">下架</el-button>
                                                        </span>
                                                    </el-table-column>
                                                </el-table>
</template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="20" layout="total, prev, pager, next" :total="totalNum">
        </el-pagination>

        <el-dialog title="租赁历史" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="上一个租赁客户ID" label-width="150px">
                    <span>{{form.lastOrderUserId}}</span>
                </el-form-item>
                <el-form-item label="上一个租赁客户姓名" label-width="150px">
                    <span>{{form.lastOrderUsername}}</span>
                </el-form-item>
                <el-form-item label="上一次租赁订单号" label-width="150px">
                    <span>{{form.lastOrderNo}}</span>
                </el-form-item>
                <el-form-item label="发布时间" label-width="150px">
                    <!-- <span>{{form.lastOrderNo}}</span> -->
                </el-form-item>
                <el-form-item label="累计租赁次数" label-width="150px">
                    <span>{{form.orderCount}}</span>
                </el-form-item>
                <el-form-item label="累计租赁天数" label-width="150px">
                    <span>{{form.dayCount}}</span>
                </el-form-item>
                <el-form-item label="累计租赁资金" label-width="150px">
                    <span>{{form.rentalSum}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getAccessory,
        removeAccessory,
        getProducts,
        getStoragesId,
        deleteProductsOne,
        getProductsIds,
        patchProductsIds,
        patchProductDetails,
        getRentHistory,
        getProductdetailsCount,
        patchProducts
    } from '../../api/version'

    export default {
        data() {
            return {
                Role: sessionStorage.power,
                currentPage: 1,
                totalNum: 0,
                form: {},
                fetchList: [],
                dialogFormVisible: false
            }
        },

        created() {
            let data = {
                'where': {
                    'accessoryType': {
                        neq: 0
                    }
                },
                "limit": 20,
                "skip": 0,
            }
            getProductdetailsCount(sessionStorage.userId, JSON.stringify({
                'accessoryType': {
                    'neq': 0
                }
            })).then(res => {
                console.log(res.data)
                this.totalNum = res.data.count
            })
            getAccessory(sessionStorage.userId, JSON.stringify(data)).then(res => {

                res.data.forEach(item => {
                    getProducts(sessionStorage.userId, JSON.stringify({
                        'where': {
                            'productDetailId': item.productDetailId
                        }
                    })).then(response => {
                        item.deviceArr = response.data
                        response.data.forEach(items => {
                            getStoragesId(sessionStorage.userId, items.storageId).then(response => {
                                items.storageArr = response.data
                            })
                            getRentHistory(sessionStorage.userId, items.productId).then(res => {
                                items.rentHistory = res.data
                                console.log(res.data, 'gg')
                            })
                        })
                    })



                })
                this.fetchList = res.data
                console.log(res.data, 'ff')

            }, err => {
                console.log(err)
            })

        },

        methods: {
            handleOnlined(index, row, props) {
                console.log(props)
                this.$confirm('此操作将该设备设置为上架, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    patchProducts(sessionStorage.userId, row[index].productId, {
                        isOnline: true
                    }).then(res => {
                        if (res.data) {
                            row[index].isOnline = true
                            ++props.productCount
                            this.$message({
                                message: '上架成功',
                                type: 'success'
                            });
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消上架'
                    });
                });

            },
            handleOffd(index, row, props) {
                this.$confirm('此操作将该设备设置为下架, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    patchProducts(sessionStorage.userId, row[index].productId, {
                        isOnline: false
                    }).then(res => {
                        if (res.data) {
                            row[index].isOnline = false
                            --props.productCount
                            this.$message({
                                message: '下架成功',
                                type: 'success'
                            });
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消下架'
                    });
                });

            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.loading = true

                let data = {
                    'where': {
                        'accessoryType': {
                            neq: 0
                        }
                    },

                    "limit": 20,
                    "skip": 20 * (--val),
                }
                getAccessory(sessionStorage.userId, JSON.stringify(data)).then(res => {

                    res.data.forEach(item => {
                        getProducts(sessionStorage.userId, JSON.stringify({
                            'where': {
                                'productDetailId': item.productDetailId
                            },
                        })).then(response => {
                            item.deviceArr = response.data
                            response.data.forEach(items => {
                                getStoragesId(sessionStorage.userId, items.storageId).then(response => {
                                    items.storageArr = response.data
                                })
                                getRentHistory(sessionStorage.userId, items.productId).then(res => {
                                    items.rentHistory = res.data
                                    console.log(res.data, 'gg')
                                })
                            })
                        })



                    })
                    this.fetchList = res.data
                    this.loading = false
                    console.log(res.data, 'ff')

                }, err => {
                    console.log(err)
                })


            },
            handleView(index, row) {
                if (row.result) {
                    this.dialogFormVisible = true
                    this.form = row.result
                } else {
                    const h = this.$createElement;
                    this.$message({
                        message: h('p', null, [
                            h('span', null, '暂无租赁历史 '),
                            h('i', {
                                style: 'color: teal'
                            })
                        ])
                    });
                }
            },
            editDevice(index, row) {
                this.$router.push('/editEquipmentX/' + row[index].productId)

            },
            deleteDevice(index, row) {
                console.log(row)
                //删除设备
                this.$confirm('此操作将删除该设备, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteProductsOne(sessionStorage.userId, row[index].productId).then(res => {
                        if (res.data) {
                            this.$message({
                                message: '成功删除',
                                type: 'success'
                            });
                            row.splice(index, 1)
                        }
                    }, err => {
                        this.$message.error('删除失败')
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleAdd(index, row) {
                this.$router.push('/addEquipmentX/' + row.productDetailId)
            },
            handleAddNew() {
                this.$router.push('/addOptional')
            },
            handleOnline(index, row) {
                this.$confirm('此操作将该选配设置为上架, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    patchProductDetails(sessionStorage.userId, row.productDetailId, {
                        isOnline: true
                    }).then(res => {
                        if (res.data) {
                            row.isOnline = true
                            this.$message({
                                message: '上架成功',
                                type: 'success'
                            });
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消上架'
                    });
                });

            },
            handleOff(index, row) {
                this.$confirm('此操作将该选配设置为下架, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    patchProductDetails(sessionStorage.userId, row.productDetailId, {
                        isOnline: false
                    }).then(res => {
                        if (res.data) {
                            row.isOnline = false
                            this.$message({
                                message: '下架成功',
                                type: 'success'
                            });
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消下架'
                    });
                });

            },
            handleEdit(index, val) {
                this.$router.push('/editOptional/' + val.productDetailId)
            }
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// OptionalList.vue?732602f5